module.exports = __webpack_public_path__ + "media/images/iconPlus--dark-09ee224c01feebdfdd5dd5163084bcbf.png";